export default {
  app: {
    title: "FaceID Admin",
    welcome: "Xush kelibsiz",
  },
  nav: {
    dashboard: "Bosh sahifa",
    companies: "Kompaniyalar",
    sessions: "Sessiyalar",
    analytics: "Analitika",
    funnel: "Voronka",
    verdicts: "Qarorlar",
    performance: "Ishlash",
    tenants: "Mijozlar",
    sdkFunnel: "SDK oqimi",
    sdkDevices: "SDK qurilmalar",
    uploadRejections: "Rad etilgan yuklashlar",
    identities: "Shaxslar",
    mobile: "Mobil",
    mobileUsers: "Foydalanuvchilar",
    mobileDevices: "Qurilmalar",
    mobileAccessEvents: "Kirish hodisalari",
    mobileQrRequests: "QR so'rovlar",
    catalog: "Katalog",
    catalogServices: "Xizmatlar",
    catalogCategories: "Toifalar",
    apiLogs: "API loglar",
    auditLogs: "Audit loglar",
    users: "Foydalanuvchilar",
    settings: "Sozlamalar",
  },
  auth: {
    loginTitle: "Tizimga kirish",
    email: "Email",
    password: "Parol",
    totpCode: "2FA kod",
    loginBtn: "Kirish",
    logout: "Chiqish",
    invalidCredentials: "Email yoki parol noto'g'ri",
    needTotp: "TOTP kod kerak",
  },
  dashboard: {
    title: "Umumiy ko'rsatkichlar",
    todaySessions: "Bugungi sessiyalar",
    totalSessions: "Jami sessiyalar",
    successRate: "Muvaffaqiyat darajasi",
    abandonRate: "Tashlab ketilgan",
    activeCompanies: "Faol kompaniyalar",
    avgResponseTime: "O'rtacha javob vaqti",
    recentActivity: "So'nggi faoliyat",
    weeklyChart: "So'nggi 7 kun sessiyalari",
    passed: "Muvaffaqiyatli",
    failed: "Muvaffaqiyatsiz",
    abandoned: "Yakunlanmagan",
    ofTerminal: "{passed} / {terminal} yakunlangan",
    ofAllSessions: "Barcha {total} sessiyaga nisbatan {pct}",
    noVerdict: "{n} ta sessiya qarorga yetmagan",
    outcomeMix: "Sessiyalar nima bilan tugadi — so'nggi 7 kun",
    outcomeMixHint:
      "Oynadagi har bir sessiya hozirgi holati bo'yicha, shuning uchun bo'laklar hammasini qoplaydi. «Muddati o'tgan» — supurilgan guruh va unda ikki xil holat bor: rasm umuman kelmagan, hamda rasm kelib, rad etilib, keyin hech kim qaytmagan. Bularni ajratish uchun urinishlar soni kerak, bu jamlanmada esa u yo'q — Voronka sahifasi o'sha bo'linishni urinishlarning o'zidan hisoblaydi.",
    mix: {
      passed: "Muvaffaqiyatli",
      failed: "Rad etilgan",
      inProgress: "Rasm yuborilgan, qaror yo'q",
      pending: "Rasm hali yuborilmagan",
      expired: "Qarorsiz muddati o'tgan",
      cancelled: "Bekor qilingan",
      other: "Boshqa holat",
    },
  },
  analytics: {
    funnelTitle: "Voronka — qayerda yo'qotyapmiz",
    verdictsTitle: "Qarorlar — nima asosida hal qilindi",
    sessionFunnel: "Sessiyalar voronkasi",
    gateFunnel: "Darvozalar bo'yicha (urinishlar)",
    abandonment: "Tashlab ketish turlari",
    abandonmentHint: "Farq bitta narsada: rasm kelganmi yoki yo'q. Birinchisida SDK ochilgan, lekin rasm umuman yuborilmagan — bu SDK/UX muammosi. Ikkinchisida rasm kelgan, rad etilgan va odam boshqa qaytmagan. Uchinchisi esa yagona haqiqiy rad javobi — barcha urinishlar sarflangan.",
    retryCurve: "Urinish bo'yicha muvaffaqiyat",
    retryHint: "Qayta urinish haqiqatan yordam beradimi? Sessiya faqat oxirgi qarorni saqlaydi, shuning uchun bu jadval urinish qatorlaridan o'qiladi.",
    stages: {
      created: "Sessiya yaratildi",
      frames_submitted: "Kadr yuborildi",
      verdict_reached: "Qarorga yetdi",
      passed: "O'tdi",
    },
    abandon: {
      neverStarted: "Rasm umuman kelmagan",
      gaveUp: "Rasm keldi, rad etildi — qaytmagan",
      exhausted: "Barcha urinishlar sarflangan",
    },
    gates: {
      detection: "Yuz aniqlash",
      liveness: "Tiriklik (passiv)",
      challenge: "Challenge",
      deepfake: "Deepfake",
      match: "Moslik",
    },
    gate: "Darvoza",
    reached: "Yetib keldi",
    gatePassed: "O'tdi",
    gateRejected: "Rad etdi",
    gateSkipped: "Ishlamadi",
    rejectionRate: "Rad etish ulushi",
    attemptNo: "Urinish",
    attempts: "Jami",
    passed: "O'tgan",
    notPassed: "O'tmagan",
    passRate: "Muvaffaqiyat",
    noAttemptsTitle: "Urinish ma'lumoti yo'q",
    noAttemptsHint: "attempts jadvali 0016 migratsiyasidan keyingina to'ldiriladi. Nol — «hech kim yiqilmadi» degani emas, «hali yozilmagan» degani.",
    ofTotal: "jamidan {pct}",
    lostHere: "shu yerda {n} yo'qoldi ({pct})",
    similarityTitle: "O'xshashlik taqsimoti",
    livenessTitle: "Tiriklik — composite ball",
    livenessMedianTitle: "Tiriklik — median (darvoza shu yerda)",
    livenessMedianHint: "{gate} chegarasi aynan medianga qo'llanadi. Faqat shu darvoza ishlagan urinishlar, uning o'z qarori bo'yicha bo'lingan.",
    livenessCompositeHint: "Bu sessiyada saqlanadigan aralash ball (0.55·median + 0.30·min + 0.15·dispersiya). Unga hech qanday chegara qo'llanmaydi — shuning uchun bu yerda darvoza chizig'i yo'q.",
    noAttemptScores: "Urinish ballari hali yozilmagan",
    noAttemptScoresHint: "Median attempts.scores dan o'qiladi — u 0016 migratsiyasidan keyin to'ldiriladi.",
    candidateThreshold: "Taklif qilinayotgan chegara",
    thresholdMark: "Amaldagi",
    candidateMark: "Taklif",
    thresholdScope: "Slayder faqat MOSLIK qarorini qayta hisoblaydi. Undan oldin rad etilgan sessiyalar (spoof, challenge, govt foto yo'q) umuman o'xshashlik bermagan va chegarani pasaytirish ularni qutqarmaydi.",
    scoredSessions: "Ball olgan sessiyalar",
    currentlyPassed: "Hozir o'tgan",
    wouldPass: "Yangi chegarada",
    netChange: "Sof o'zgarish",
    nearThreshold: "Chegaradan ±{band} ichida {n} ta sessiya",
    nearThresholdHint: "Chegarani bir qadam surish aynan shularning qarorini almashtiradi.",
    thresholdDrift: "Bu tanlovda bir nechta chegara bor — sessiyalar turli qoida bo'yicha baholangan",
    medianGate: "Median darvoza",
    failuresOverTime: "Rad etish sabablari vaqt bo'yicha",
    spoofBasis: "Spoof qarori nimaga asoslangan",
    spoofSamples: "Rad etishlar soni",
    spoofMedian: "O'rtacha median",
    spoofRange: "Median diapazoni",
    spoofVariance: "O'rtacha dispersiya",
    spoofFrames: "O'rtacha kadr soni",
    required: "talab",
    noSpoofData: "Spoof tafsiloti yo'q",
    noSpoofDataHint: "Bu raqamlar attempts.failure_details dan o'qiladi — u 0016 migratsiyasidan keyin yoziladi.",
    noScores: "Ball olgan sessiya yo'q",
    groupedNote: "Ustunlar {width} kenglikda birlashtirilgan",
    dateFrom: "Boshlanishi",
    dateTo: "Tugashi",
    percentilesApprox: "Bu paneldagi p-qiymatlar soatlik gistogrammalardan taxminlanadi, ya'ni har biri o'zi tushgan kechikish bo'lagi kengligi darajasida aniq (≈ bilan belgilangan). {cap} va undan yuqori qiymat pastki chegara sifatida ko'rsatiladi — gistogramma undan nariga ajratmaydi.",
    reset: "Tozalash",
  },
  forensics: {
    title: "Sessiya tahlili",
    backToList: "Sessiyalarga",
    attempt: "{n}-urinish",
    frames: "{n} kadr",
    afterGap: "oldingisidan {s} s keyin",
    gateTable: "Darvozalar — nima o'lchandi, nima talab qilindi",
    timings: "Bosqich vaqtlari",
    frameStrip: "Kadrlar",
    noFrameData: "Bu urinish uchun kadr diagnostikasi yo'q",
    noAttempts: "Urinish yozuvi yo'q",
    noAttemptsHint: "Bu sessiya attempts jadvali to'ldirila boshlagunga qadar (0016 migratsiyasi) yakunlangan, yoki birorta kadr yuborilmagan.",
    imagesGone: "Rasmlar faqat oxirgi urinishniki saqlanadi — har yuborishda ustidan yoziladi. Raqamlar esa har bir urinish uchun to'liq.",
    imagesMismatch: "Saqlangan rasmlar soni bu urinish yuborgan kadrlar soniga to'g'ri kelmadi — ular oldingi urinishniki, shuning uchun ko'rsatilmayapti.",
    indeterminate: "Saqlangan qiymat chegaraga juda yaqin — yaxlitlash tufayli bu chiziq hal qilinmadi",
    noFace: "yuz yo'q",
    multiFace: "bir nechta yuz",
    thresholdFromConfig: "Hozirgi konfiguratsiyadan olingan — urinishdan keyin o'zgargan bo'lishi mumkin",
    thresholdFromSession: "Sessiya yaratilganda saqlangan — aynan shu urinishni hukm qilgan qiymat",
    configLabel: "konfig",
    sessionLabel: "aniq",
    byPinfl: "Shu PINFL dagi boshqa sessiyalar",
    byIp: "Shu IP dagi boshqa sessiyalar",
    openShort: "Ochish",
    criteria: {
      median: "median",
      minimum: "eng past (kesilgan)",
      variance: "dispersiya",
      samples: "kadr soni",
      similarity: "o'xshashlik",
      deepfake: "deepfake",
      frames_with_face: "yuzli kadr",
      frames_with_multiple_faces: "ko'p yuzli kadr",
    },
    state: {
      passed: "o'tdi",
      rejected: "rad etdi",
      not_run: "ishlamadi",
    },
  },
  perf: {
    scopedHeadroom: "Diqqat: filtr qo'yilgan — cho'qqi tanlangan qism bo'yicha, quvvat esa butun tizimniki. Bu yerdagi zaxira flotda zaxira borligini anglatmaydi.",
    title: "Ishlash — qanchalik tez, qancha zaxira bor",
    headroom: "Yuk va zaxira",
    peakMinute: "Eng band daqiqa",
    peakRps: "Eng yuqori tezlik",
    perSecond: "sekundiga",
    capacity: "O'lchangan quvvat",
    measuredOn: "{d} da o'lchangan",
    spare: "Bo'sh zaxira",
    capacityHint: "Quvvat — yuklama sinovida o'lchangan raqam, spetsifikatsiya emas. Worker soni, MAX_INFLIGHT yoki GPU o'zgarsa, qayta o'lchash kerak. Daqiqa bo'yicha olinadi: soatlik o'rtacha aynan chegarani buzadigan cho'qqini yassilaydi.",
    whichBackend: "Qaysi backend xizmat qildi",
    backendHint: "GPU jimgina CPU'ga tushib qolsa, bu faqat kechikish bo'lib ko'rinadi. Shuning uchun alohida ustun. «none» — tahlilga umuman yetmagan sessiyalar.",
    stageTitle: "Vaqt qayerga ketadi (urinish ichida)",
    stage: "Bosqich",
    stages: {
      signature: "Imzo tekshiruvi",
      analyze: "Model tahlili",
      challenge: "Challenge",
      deepfake: "Deepfake",
      govt_photo: "Govt foto (IMV)",
      match: "1:1 moslik",
    },
    samples: "Namunalar",
    avg: "O'rtacha",
    p50: "p50",
    p95: "p95",
    p99: "p99",
    noStageData: "Bosqich vaqtlari hali yozilmagan",
    noStageDataHint: "Bu ma'lumot attempts.stage_durations dan keladi — u 0016 migratsiyasidan keyingi tekshiruvlarda to'ldiriladi.",
    endpoints: "Endpoint kechikishlari",
    endpoint: "Endpoint",
    endpointScope: "Butun flot bo'yicha — ilova bo'yicha ajratib bo'lmaydi: api_logs da application_id hech qachon yozilmaydi (Sprint 9 gacha). Sana filtri qo'yilmasa, oxirgi 7 kun o'qiladi.",
    calls: "Chaqiruvlar",
    errorRate: "Xato ulushi",
    slowest: "Eng sekin sessiyalar",
    duration: "Davomiyligi",
  },
  tenants: {
    noErrorRate: "* API xato ulushi ko'rsatilmaydi: api_logs da ilova atributsiyasi yo'q (Sprint 9 gacha). Soxta 0.0% ko'rsatgandan ko'ra ustunni olib tashlash to'g'riroq.",
    quotaScope: "Kvota har doim joriy kalendar oyi bo'yicha va sana filtriga bo'ysunmaydi.",
    title: "Mijozlar — kim ishlatyapti, ular uchun qanday ishlayapti",
    application: "Ilova",
    sessions: "Sessiyalar",
    passRate: "Muvaffaqiyat",
    abandonRate: "Tashlab ketish",
    quota: "Kvota",
    projected: "prognoz {n}",
    projectionHint: "Oy oxiriga to'g'ri chiziqli prognoz: {n}. Bu bashorat emas, «kvotaga yetamizmi» degan ishora.",
    rules: "Amaldagi qoidalar",
    spoofOff: "spoof o'chiq",
    livenessOff: "liveness o'chiq",
    outlierTitle: "{n} ta ilova o'rtachadan sezilarli past",
    outlierBody: "{names} — flot o'rtachasi {mean}, chegara {floor}. Bunday farq odatda model emas, integratsiya yoki kadr sifati muammosi bo'ladi.",
    thresholdDrift: "Flotda bir nechta chegara ishlayapti: {list}",
    thresholdDriftHint: "Bir xil yuz bir ilovada o'tib, boshqasida yiqilishi mumkin. Bu ilgari sezilmasdan ishlab ketgan.",
    fleetNote: "Flot o'rtachasi {mean}, {n} ta ilova bo'yicha. Kamida {min} yakunlangan sessiyasi bor ilovalargina hisobga olinadi — kam sonli natija shovqin, va shovqinni belgilash bayroqni qadrsizlantiradi.",
    noFleet: "Taqqoslash uchun yetarli ilova yo'q — hech narsa belgilanmaydi.",
  },
  sdk: {
    funnelTitle: "SDK oqimi — telefon ularni qayerda yo'qotdi",
    devicesTitle: "SDK qurilmalar — ular nimada ishlagan",
    platform: "Platforma",
    platforms: {
      android: "Android",
      ios: "iOS",
    },
    bundleId: "Ilova bundle id",
    sdkVersion: "SDK versiyasi",
    nFlows: "{n} ta oqim",
    testTraffic: "Test trafigi",
    testTrafficHint: "Emulyator va debug qurilishlari. Odatda hisobga olinmaydi — aks holda ichki sinov ishlab chiqarish raqamlari ichida o'tirib qoladi.",
    window: "Oyna (server vaqti)",
    received: "Kelgan oqimlar",
    counted: "Hisobga olingan",
    countedHint: "Sahifadagi barcha ulushlar shu songa bo'linadi",
    excluded: "Chiqarib tashlangan",
    excludedBreakdown: "emulyator {emulator} · debug {debuggable}",
    excludedOverlap: "Jami — ikkita sonning yig'indisi emas: emulyatordagi debug qurilishi bitta qator, va uni ikki marta sanash chiqarib tashlanganlar sonini o'zi olingan to'plamdan kattaroq qilib qo'yardi.",
    testTrafficCounted: "Ichida test trafigi",
    includedOverlap: "Test trafigi hisobga qo'shilgan. Emulyator va debug sonlari kesishadi — bitta qator ikkalasi ham bo'lishi mumkin — shuning uchun ularni qo'shib umumiy son chiqarib bo'lmaydi.",
    clientScope: "Mijoz: {id}",
    testTrafficOn: "Test trafigi ham qo'shilgan",
    empty: {
      never: "SDK telemetriyasi hali umuman kelmagan",
      neverHint: "Bu jadval Android SDK schema_version 3 bilan chiqqanidan keyin to'la boshlaydi. Hozir bu yerda «0%» chizish — o'lchanmagan narsani o'lchandi deb ko'rsatish bo'lardi, shuning uchun panellar chizilmaydi.",
      window: "Bu oynada oqim yo'q",
      windowHint: "Telemetriya kelgan, lekin tanlangan sanalar ichida emas. Sana oralig'ini kengaytiring.",
      testOnly: "Bu oynadagi hamma narsa test trafigi edi",
      testOnlyHint: "{n} ta oqim emulyator yoki debug qurilishidan kelgan va ishlab chiqarish raqamlaridan chiqarib tashlangan. Ularni ko'rish uchun yuqoridagi «Test trafigi» tugmasini yoqing.",
    },
    pairTitle: "Ikki yarim: telefon nimani ko'rdi, server nimani ko'rdi",
    pairHint: "Server sessiya paydo bo'lgandan keyingina ko'ra oladi, sessiyalarning 54.3% i esa yaratilib, rasm umuman kelmaydi — server tomonda bu shunchaki jimlik. Yuqoridagi sakkiz bosqich telefonning o'zi bilgan narsa; ikkala yarim bitta sahifada birinchi marta shu yerda turibdi.",
    clientHalf: "Telefon tomoni (SDK)",
    serverHalf: "Server tomoni (sessiyalar)",
    serverHalfHint: "Bu yarim — o'sha sana oralig'idagi barcha sessiyalar; mijoz filtri qo'yilgan bo'lsa, u ikkala yarimga ham qo'llanadi. Platforma, SDK versiyasi va bundle id sessiyalarda umuman yo'q, shuning uchun ular faqat telefon tomonini toraytiradi. Ikki yarim qanchalik ustma-ust tushishini quyidagi bog'lanish paneli sanaydi.",
    pairWaiting: "Telefon tomoni bo'sh — SDK hali telemetriya yubormayapti.",
    unstaged: "{n} ta oqim sakkizlikdan tashqarida (REGISTRATION va QR_LOGIN oqimlari — ularning o'z bosqichlari bor). Ular LAUNCHED ga qo'shilmagan: aks holda voronkaning boshi unga hech qachon kirmagan odamlar bilan shishib ketardi.",
    stages: {
      LAUNCHED: "SDK ochildi",
      SESSION_CREATED: "Sessiya yaratildi",
      CENTERING: "Yuzni markazlash",
      FACE_DETECTED: "Yuz topildi",
      FRAMED: "Ovalga to'g'ri joylashdi",
      CHALLENGE: "Harakat so'raldi",
      PROCESSING: "Yuborildi, kutilmoqda",
      RESULT_SHOWN: "Natija ko'rsatildi",
    },
    joinTitle: "Sessiya bilan bog'lanish",
    joinHint: "Bog'lanish LEFT join va shunday qolishi kerak: sessiyasiz oqimlar aynan shu jadval yaratilgan sabab — kamera ruxsati berilmagan yoki sessiya olinmagan holatlar. INNER join ularni jimgina o'chirib yuborardi va yangi jadvalda o'sha eski ko'r nuqta qolardi.",
    join: {
      matched: "Sessiyasi topildi",
      sessionless: "Sessiyasi umuman bo'lmagan",
      unmatched: "Sessiya id bor, lekin topilmadi",
      matchedPassed: "Server: o'tdi",
      matchedFailed: "Server: rad etdi",
      matchedOpen: "Server: qarorga yetmagan",
    },
    matchedHint: "Faqat sessiyasi topilgan oqimlar bo'yicha.",
    abandonTitle: "Qayerda tashlab ketishdi",
    abandonHint: "Jami {n} ta oqim tashlab ketilgan. PROCESSING dagi uzoq p90 — «qotib qoldi deb o'yladim» degan eng aniq belgi, sekin server emas.",
    abandonWhere: "Bosqich bo'yicha soni",
    abandonHowLong: "Ketishdan oldin qancha turgan",
    abandonedFlows: "Tashlab ketilgan oqimlar",
    stage: "Bosqich",
    ofAbandoned: "Tashlab ketishlardan",
    samples: "Namunalar",
    samplesHint: "«Namunalar» — persentil bo'linuvchisi va u oqimlar soniga teng emas: oqim qayerda to'xtaganini yozib, qancha turganini yozmasligi mumkin. Hech kim xabar qilmagan joyda 0 emas, chiziqcha turadi.",
    errorsTitle: "Nima buzildi (error_kind)",
    errorsHint: "Ulush barcha hisobga olingan oqimlarga nisbatan olinadi: «oqimlarning 3% i kamera ruxsatida o'lgan» — harakatga sabab bo'ladigan jumla shu.",
    errorKind: "Xato sinfi",
    ofFlows: "Oqimlardan",
    noErrors: "Xato qayd etilmagan",
    chartTopN: "Grafikda eng kattasi {shown} tasi; jadvalda barcha {total} tasi.",
    errorKindsCut: "Oynada {total} xil xato sinfi bo'lgan, ro'yxatda eng kattasi {shown} tasi. error_kind past kardinallikda bo'lishi kerak — chegaraga yaqinlashishning o'zi topilma: SDK qurilishi sinf nomlarini o'ylab chiqarayotgan bo'lishi mumkin.",
    retryTitle: "Qayta urinish — ular taklifni ko'rganmi?",
    retryHint: "Server tomonda o'lchangan edi: tashlab ketganlarning 76% i ikkita urinish qolgan holda BITTA rad javobidan keyin ketadi. Ikkinchi qator — kimdir qayta urinish taklifini haqiqatan ko'rganining isboti. «Sessiyalar» ustuni takrorlanmas sessiya id larini sanaydi: sessiyasiz oqimning qaytadigan joyi yo'q.",
    attempt: "Urinish",
    attemptN: "{n}-urinish",
    noAttempts: "Urinish qatorlari yo'q",
    flows: "Oqimlar",
    sessions: "Sessiyalar",
    reachedResult: "Natijaga yetdi",
    abandoned: "Tashlab ketilgan",
    abandonRate: "Tashlab ketish ulushi",
    passed: "O'tdi",
    p50: "p50",
    p90: "p90",
    p99: "p99",
    timingTitle: "Kutish vaqti va uning tarmoq ulushi",
    timingHint: "processing_ms — spinner turgan butun vaqt, ya'ni foydalanuvchi his qiladigan kutish. upload_ms uning ichidan tarmoqni ajratadi va schema_version 3 da ham majburiy emas: yo'qligi «xabar qilinmagan» degani, «0 ms» emas. Shuning uchun har birining o'z namuna soni bor.",
    processing: "Ishlov (spinner)",
    upload: "Yuklash (tarmoq)",
    processingP50: "Ishlov p50",
    processingP90: "Ishlov p90",
    processingP99: "Ishlov p99",
    uploadP50: "Yuklash p50",
    uploadP90: "Yuklash p90",
    cancelled: "Ishlov paytida bekor qilingan",
    cancelledOf: "{total} tadan {n} ta",
    nSamples: "{n} ta namuna",
    noUpload: "Hech bir oqim yuklash vaqtini yubormagan — bu 0 ms emas, o'lchov umuman yo'q.",
    byDeviceTitle: "Eng yomon qurilmalar (Build.DEVICE)",
    byDeviceHint: "Build.DEVICE — plata kod nomi: bitta model, va marketing nomi o'zgarsa ham o'zgarmaydi.",
    byHardwareTitle: "Eng yomon chipsetlar (Build.HARDWARE)",
    byHardwareHint: "Build.HARDWARE — SoC, ya'ni butun chipset oilasi. «Bitta model buzuq» va «shu chipsetdagi hamma telefon buzuq» boshqa-boshqa xatolar, egasi ham boshqa.",
    device: "Qurilma (DEVICE)",
    hardware: "Chipset (HARDWARE)",
    droppedRatio: "Tashlangan kadrlar",
    frameSamples: "Kadr namunalari",
    deviceModels: "Modellar",
    unknownDevice: "Qurilma ma'lumoti kelmagan",
    noGroups: "Hech bir guruh {n} ta oqim chegarasidan o'tmadi",
    suppressed: "Chegara: guruh uchun kamida {min} ta oqim. Undan pastda {groups} ta guruh, jami {flows} ta oqim qoldi — kam sonli ulush shovqin, lekin bu jami raqam «yuzta model, har biri besh martadan yiqilgan» degan keng muammoni ko'rsatadi.",
    topN: "{total} tadan {shown} tasi ko'rsatilgan",
    droppedTitle: "Tashlangan kadrlar ulushi (qurilma bo'yicha)",
    droppedHint: "Bitta modelda yuqori ulush — kamera yoki isish nosozligi. Server tomonda u INSUFFICIENT_FACE_FRAMES bo'lib chiqadi va foydalanuvchining aybi kabi o'qiladi.",
    noFrameCounts: "Hech bir guruh kadr sonini yubormagan",
    droppedMissing: "{n} ta guruh kadr sonini umuman yubormagan — ular 0% emas, o'lchovsiz.",
    apiLevelTitle: "API daraja bo'yicha",
    apiLevelHint: "Build.VERSION.SDK_INT marketing versiyasidan foydaliroq: kamera va ML xatti-harakati aynan API darajaga bog'liq. iOS da bunday maydon yo'q, Android da esa qurilma bloki kelmagan bo'lishi mumkin — ikkalasi ham 0 emas, «o'lchanmagan».",
    apiLevel: "API daraja",
    densityTitle: "Ekran zichligi va ovaldan chiqib-kirish",
    densityHint: "framing_flap_count — «ovalga kirib-chiqib turish» patologiyasi. Zichliklar bo'yicha tekis tarqalgan bo'lsa yo'riqnoma muammosi; bitta dpi to'plamida to'plansa, o'sha ekranlarda oval noto'g'ri o'lchamda — ya'ni tuzatsa bo'ladigan UI xatosi.",
    density: "Zichlik (dpi)",
    flapSamples: "Flap namunalari",
    flapSamplesHint: "O'rtacha va p90 faqat qiymat yuborgan oqimlar bo'yicha hisoblanadi — shuning uchun yonida oqimlar soni emas, namunalar soni turadi.",
    avgFlaps: "O'rtacha flap",
    p90Flaps: "p90 flap",
    integratorsTitle: "Integratorlar (host ilovalar)",
    integratorsHint: "app_bundle_id bo'yicha, application_id emas: Application.bundle_ids ni hali hech narsa to'ldirmaydi, shuning uchun application_id har qatorda NULL. Bundle id chaqiruvchi tomonidan yuboriladi — u segmentlaydi, lekin ilovani tasdiqlamaydi.",
    bundleUnverified: "Mijoz filtri qo'yilmagan: bundle id ni chaqiruvchining o'zi yuboradi, ya'ni haqiqiy SDK tokeni bo'lgan har kim boshqa birovning bundle id si ostida oqim yozishi mumkin. Shu holatda bu qatorlar ishora, dalil emas. Mijoz bo'yicha filtrlansa, bundle ostida qolgani o'sha mijoz yuborgan narsa bo'ladi.",
    sdkVersions: "SDK versiyalari",
    versionClickHint: "Versiya tegiga bosilsa, butun sahifa — qurilmalar, ekranlar, vaqtlar — o'sha qurilishga filtrlanadi. Versiyalar bo'yicha tashlab ketish ulushi esa quyidagi «Relizlar» jadvalida, hech narsani filtrlamasdan turadi.",
    releasesTitle: "Relizlar — yangi versiya vaziyatni yomonlashtirdimi?",
    releasesHint: "Har bir qator — bitta ilova va bitta SDK qurilishi; qurilishlar chiqarilish tartibida yonma-yon turadi. Oxirgi ustun — shu ilovaning ro'yxatdagi oldingi qurilishidan farq, foiz punktida: musbat son yangi reliz ko'proq odamni yo'qotayotganini bildiradi. Diqqat: chegaradan o'tmagan qurilishlar ro'yxatga umuman tushmaydi, shuning uchun «oldingi» — vaqt bo'yicha eng yaqin reliz emas, ro'yxatdagi oldingisi.",
    version: "Versiya",
    deltaVsPrev: "Oldingi versiyaga nisbatan",
    ppSuffix: "f.p.",
    baselineVersion: "birinchi qurilish",
    releaseSuppressed: "Chegaradan past: {groups} ta (ilova, versiya) juftligi, jami {flows} ta oqim. Endigina chiqarilgan versiya doim shu yerdan boshlanadi — uning yo'qligi «nol» degani emas.",
    noReleases: "Taqqoslash uchun versiya qatorlari yo'q",
    versionsTitle: "Versiyalar qiyosi — har bir qurilish qanday ishlayapti",
    versionsHint: "Har bir SDK qurilishi uchun bitta satr, platforma bo'yicha guruhlangan va ular aralashtirilmaydi — bir xil versiya satri ikkalasida ham uchraydi. Versiyani bosish butun sahifani shu qurilishga filtrlaydi. Qurilmalar sahifasidagi relizlar jadvalidan farqli, bu jadvalni saralash mumkin: satrlar mustaqil, yuqoridagi satr bilan solishtirilmaydi.",
    versionsEdgeHint: "Oyna ichida qurilishning birinchi va oxirgi kuni to'liq emas, shuning uchun yangi chiqqan versiyada oqim kam bo'ladi — ulushlarini o'qishdan oldin oqim soniga qaring.",
    share: "Ulush",
    passRate: "O'tish darajasi",
    errorFlows: "Xatolar",
    topError: "Eng ko'p uchragan xato",
    firstSeen: "Birinchi ko'rinish",
    lastSeen: "Oxirgi ko'rinish",
    noVersions: "Bu oynada versiya satrlari yo'q",
    notMeasured: "O'lchanmagan",
    shareHint: "Oynadagi shu platformaning oqimlariga nisbatan, butun oynaga emas: bitta platforma ichidagi ulushlar 100% ni tashkil qiladi. Android va iOS — ikki xil to'plam va ular hech qachon birlashtirilmaydi.",
    mixedPlatforms: "Platforma filtri bo'sh: Android va iOS bir sahifada. Qatorlar aralashmaydi, lekin ularni bir-biri bilan solishtirmang — o'lchanadigan maydonlarning katta qismi iOS da umuman yo'q.",
  },
  rejections: {
    title: "Rad etilgan yuklashlar — server nimani qaytargan",
    sessionTitle: "Rad etilgan yuklashlar",
    empty: "Rad etilgan yuklash yo'q",
    noData: "Bu oraliqda yuklash bo'lmagan",
    loadFailed: "Rad etilgan yuklashlarni o'qib bo'lmadi",
    time: "Vaqt",
    status: "Status",
    category: "Sabab",
    platform: "Platforma",
    duration: "Davomiyligi",
    uploads: "Yuklashlar",
    rejected: "Rad etilgan",
    rejectedShare: "Rad etilgan ulushi",
    dailyTitle: "Kunlar bo'yicha — yuklashlar va rad etilganlar",
    categoriesTitle: "Sabablar",
    platformsTitle: "Platformalar bo'yicha",
    count: "Soni",
    share: "Ulushi",
    rangeHint: "Eng ko'pi {n} kun",
    rangeClamped: "Oraliq {n} kun bilan cheklangan — boshlanish sanasi surildi",
    noCategory: "Sabab yozilmagan",
    httpCode: "HTTP {status}",
    endpoint: "Manzil",
    sessionScope: "Qurilmadan kelgan va rad etilgan so'rovlar — faqat kadr yuklash emas.",
    codes: {
      FRAME_TAMPERED: "Kadr o'zgartirilgan",
      INVALID_TOKEN: "Token yaroqsiz",
      INVALID_IMAGE: "Rasm yaroqsiz",
      FRAMES_TOO_MANY: "Kadrlar juda ko'p",
      FRAMES_TOO_FEW: "Kadrlar yetarli emas",
      SESSION_EXPIRED: "Sessiya muddati tugagan",
      SESSION_NOT_FOUND: "Sessiya topilmadi",
      ATTESTATION_FAILED: "Ilova tasdiqdan o'tmadi",
      CLIENT_DISCONNECT: "Mijoz aloqani uzdi",
      VALIDATION_ERROR: "So'rov formati noto'g'ri",
    },
    details: {
      body_hash: "So'rov tanasi hash'i mos emas",
      clock_skew: "Qurilma soati noto'g'ri",
      hmac_mismatch: "Imzo mos emas",
      missing_bearer: "Token yuborilmagan",
      not_sdk_token: "SDK tokeni emas",
      wrong_session: "Boshqa sessiya tokeni",
      bad_subject: "Token egasi sessiya emas",
      unknown_session: "Token ko'rsatgan sessiya yo'q",
      bad_payload_json: "JSON buzuq",
      frame_too_large: "Kadr hajmi juda katta",
      total_too_large: "Umumiy hajm juda katta",
      part_too_large: "Yuborilgan qism hajmi juda katta",
      metadata_too_large: "Metama'lumot hajmi juda katta",
      too_many: "Kadrlar soni juda ko'p",
      missing_proof: "Kadr tasdig'i (proof) yo'q",
      too_few: "Kadrlar kam",
      too_many_files: "Fayllar soni juda ko'p",
      bad_metadata_json: "Metama'lumot JSON buzuq",
      metadata_too_deep: "Metama'lumot juda ichma-ich",
      missing_flash_id: "Flash id yo'q",
      not_jpeg: "JPEG emas",
      body_read: "Yuklash o'rtada uzildi",
      no_route: "Bunday manzil yo'q",
    },
    platforms: {
      android: "Android",
      ios: "iOS",
      web: "Web",
      other: "Boshqa",
    },
  },
  companies: {
    title: "Kompaniyalar",
    create: "Yangi kompaniya",
    name: "Nomi",
    slug: "Slug",
    slugHint: "a-z, 0-9, -",
    inn: "STIR",
    email: "Email",
    phone: "Telefon",
    address: "Manzil",
    status: "Holati",
    createdAt: "Yaratilgan",
    actions: "Amallar",
    edit: "Tahrirlash",
    suspend: "To'xtatish",
    activate: "Faollashtirish",
    detail: "Tafsilotlar",
    applications: "Ilovalar",
    statusActive: "faol",
    statusSuspended: "to'xtatilgan",
    statusPending: "tasdiq kutilmoqda",
    createSuccess: "Kompaniya yaratildi",
    updateSuccess: "Kompaniya yangilandi",
  },
  sessions: {
    title: "Sessiyalar",
    id: "Sessiya ID",
    method: "Usul",
    status: "Holati",
    statusHint:
      "Yorliq holat so'ziga emas, urinishlar soniga qarab yoziladi: 0 urinish — rasm umuman kelmagan, 1 va undan ko'pi — rasm kelgan va rad etilgan. Xom holatni ko'rish uchun sichqonchani olib boring.",
    outcome: {
      passed: "O'tdi",
      failed: "Rad etildi",
      cancelled: "Bekor qilingan",
      awaitingPhoto: "Rasm kutilmoqda",
      retrying: "Rasm keldi, qayta urinilmoqda",
      expiredNoPhoto: "Muddati o'tgan — rasm kelmagan",
      expiredAbandoned: "Muddati o'tgan — rasm rad etilgan, qaytmagan",
    },
    pinfl: "PINFL",
    similarity: "O'xshashlik",
    liveness: "Tiriklik",
    quality: "Sifat",
    attempts: "Urinishlar",
    failureReason: "Xato sababi",
    createdAt: "Yaratilgan",
    completedAt: "Tugatilgan",
    ip: "IP manzil",
    detail: "Sessiya tafsilotlari",
    company: "Kompaniya",
    application: "Ilova",
    origin: "Manba",
    threshold: "Chegara",
    mlBackend: "ML backend",
    mlBackendNone: "Tahlil qilinmagan",
    duration: "Davomiylik",
    unmanaged: "Ilovasiz",
    thresholdDiffers: "Ushbu sahifadagi ko'pchilik qatorlardan farq qiladi",
    thresholdDrift: "Bu filtrda {count} xil chegara ishlatilgan",
    thresholdDriftHint: "Butun filtr bo'yicha, joriy sahifadan qat'i nazar",
    allStatuses: "Barcha holatlar",
    allMethods: "Barcha usullar",
    allCompanies: "Barcha kompaniyalar",
    allApplications: "Barcha ilovalar",
    allOrigins: "Barcha manbalar",
    allFailureReasons: "Barcha xato sabablari",
    allBackends: "Barcha backendlar",
    origin_sdk: "SDK",
    origin_app_login: "Ilovaga kirish",
    origin_qr_login: "QR orqali kirish",
    dateRange: "Sana oralig'i",
    searchPlaceholder: "PINFL bo'yicha qidirish",
    resetFilters: "Filtrlarni tozalash",
    clientScope: "Mijoz: {id}",
    statsTotal: "Jami",
    statsPassed: "Muvaffaqiyatli",
    statsFailed: "Muvaffaqiyatsiz",
    passRate: "Muvaffaqiyat darajasi",
    passRateHint:
      "Faqat yakunlangan sessiyalar: muvaffaqiyatli / (muvaffaqiyatli + muvaffaqiyatsiz)",
    avgSimilarity: "O'rtacha o'xshashlik",
    avgLiveness: "O'rtacha tiriklik",
    avgDuration: "O'rtacha davomiylik",
    empty: "Sessiyalar topilmadi",
    forbidden: "Bu ma'lumotlarni ko'rish uchun ruxsat yo'q",
    photos: "Rasmlar",
    govtPhoto: "Pasport rasmi",
    registryPassportPhoto: "Pasport rasmi (Shaxslar)",
    selfie: "Selfi",
    frames: "Kadrlar",
    noPhotos: "Bu sessiya uchun rasm yo'q",
  },
  // Ilova xavfsizlik tekshiruvlari — ilovalar jadvali ham, sessiyalar
  // jadvali ham shu so'zlardan foydalanadi.
  challenges: {
    head_yaw_left: "Chapga burilish",
    head_yaw_right: "O'ngga burilish",
    head_pitch_up: "Tepaga qarash",
    head_pitch_down: "Pastga qarash",
  },
  checks: {
    title: "Tekshiruvlar",
    spoof: "Spoof tekshiruvi",
    liveness: "Tiriklik tekshiruvi",
    frameTime: "Kadr vaqti tekshiruvi",
    appAttest: "iOS App Attest tekshiruvi",
    stateOn: "yoqilgan",
    stateOff: "o'chirilgan",
    disabled: "Tekshiruv o'chiq",
    disabledHint: "O'chirilgan: {checks}",
    disabledHintSession: "Bu sessiyada o'chirilgan: {checks}",
    superAdminOnly: "Tekshiruvlarni faqat super-admin o'zgartira oladi",
  },
  identities: {
    title: "Tasdiqlangan shaxslar",
    searchPlaceholder: "PINFL yoki ism bo'yicha qidirish",
    pinfl: "PINFL",
    fullName: "F.I.Sh.",
    firstName: "Ism",
    lastName: "Familiya",
    middleName: "Otasining ismi",
    passport: "Pasport",
    birthDate: "Tug'ilgan sana",
    verificationCount: "Verifikatsiyalar",
    lastVerifiedAt: "Oxirgi verifikatsiya",
    createdAt: "Yaratilgan",
    updatedAt: "Yangilangan",
    images: "Rasmlar",
    passportImage: "Pasport rasmi",
    verificationImage: "Verifikatsiya kadri",
    noImage: "Rasm yo'q",
    detail: "Shaxs tafsilotlari",
    empty: "Hozircha tasdiqlangan shaxslar yo'q",
    delete: "Shaxsni o'chirish",
    deleteConfirm:
      "{pinfl} shaxsi butunlay o'chirilsinmi? Yozuv VA ikkala rasm fayli o'chadi. Buni qaytarib bo'lmaydi.",
    deleteSuccess: "Shaxs o'chirildi",
    forbidden: "Bu sahifa faqat super adminlar uchun",
    alternativeImage: "Alternativ rasm",
    alternativeHint:
      "Alternativ rasm qo'yilganda bu shaxsning yuzi pasport rasmi emas, shu rasm bilan solishtiriladi. Pasport rasmi shaxsga o'xshamay qolgan hollarda ishlatiladi.",
    alternativeDropHint: "Rasmni shu yerga tashlang yoki bosib tanlang",
    alternativeConstraints: "JPEG, PNG yoki WebP — bitta yuz, 10 MB gacha",
    alternativeRemove: "Rasmni o'chirish",
    alternativeRemoveTitle: "Alternativ rasmni o'chirish",
    alternativeRemoveConfirm:
      "{pinfl} shaxsining alternativ rasmi o'chirilsinmi? Shundan keyin solishtirish yana pasport rasmi bilan bo'ladi.",
    alternativeUploadSuccess: "Alternativ rasm saqlandi",
    alternativeRemoveSuccess: "Alternativ rasm o'chirildi",
    alternativeTypeRejected: "Faqat JPEG, PNG yoki WebP rasm qabul qilinadi",
    alternativeTooLarge: "Rasm hajmi 10 MB dan oshmasligi kerak",
    alternativeHistory: "O'zgarishlar tarixi",
    alternativeHistoryEmpty: "Hozircha o'zgarish yo'q",
    alternativeHistoryWhen: "Sana / vaqt",
    alternativeHistoryActor: "Admin",
    alternativeHistoryAction: "Amal",
    alternativeAction_uploaded: "Yuklandi",
    alternativeAction_removed: "O'chirildi",
    alternativeErrNoFace:
      "Rasmda yuz topilmadi — yuzi aniq ko'rinadigan rasm tanlang",
    alternativeErrMultipleFaces:
      "Rasmda bir nechta yuz bor — faqat bitta yuz bo'lgan rasm tanlang",
    alternativeErrInvalidImage:
      "Fayl yaroqli rasm emas: o'qib bo'lmaydi yoki o'lchami ruxsat etilgan chegaradan tashqarida",
    alternativeErrIdentityNotFound: "Bu shaxs endi mavjud emas",
    alternativeErrNotFound: "Bu shaxsning alternativ rasmi yo'q",
  },
  mobile: {
    usersTitle: "Mobil foydalanuvchilar",
    usersSearchPlaceholder: "PINFL, ism yoki telefon",
    usersEmpty: "Hozircha mobil foydalanuvchilar yo'q",
    devicesTitle: "Mobil qurilmalar",
    devicesSearchPlaceholder: "Qurilma ID, model yoki egasi",
    devicesEmpty: "Qurilmalar yo'q",
    eventsTitle: "Kirish hodisalari",
    eventsEmpty: "Hodisalar yo'q",
    qrTitle: "QR so'rovlar",
    qrEmpty: "QR so'rovlar yo'q",
    pinfl: "PINFL",
    fullName: "F.I.Sh.",
    firstName: "Ism",
    lastName: "Familiya",
    middleName: "Otasining ismi",
    passport: "Pasport",
    birthDate: "Tug'ilgan sana",
    phone: "Telefon",
    status: "Holati",
    allStatuses: "Barcha holatlar",
    status_active: "faol",
    status_suspended: "to'xtatilgan",
    status_deleted: "o'chirilgan",
    status_revoked: "bekor qilingan",
    status_pending: "kutilmoqda",
    status_scanned: "skanerlangan",
    status_approved: "tasdiqlangan",
    status_rejected: "rad etilgan",
    status_expired: "muddati tugagan",
    status_consumed: "ishlatilgan",
    // The backend counts ALL devices (revoked included) and EVERY access
    // event (rejected/failed/QR included) — the labels say so, otherwise they
    // read as the Dashboard's "active devices" / "logins today" numbers.
    deviceCount: "Qurilmalar (jami)",
    loginCount: "Hodisalar",
    lastLogin: "Oxirgi kirish",
    lastEventAt: "Oxirgi hodisa",
    createdAt: "Yaratilgan",
    updatedAt: "Yangilangan",
    language: "Til",
    userDetail: "Foydalanuvchi tafsilotlari",
    tabProfile: "Profil",
    tabDevices: "Qurilmalar",
    tabHistory: "Tarix",
    photo: "Ro'yxatga olingan rasm",
    noPhoto: "Rasm yo'q",
    owner: "Egasi",
    platform: "Platforma",
    allPlatforms: "Barcha platformalar",
    platform_ios: "iOS",
    platform_android: "Android",
    model: "Model",
    osVersion: "OS versiyasi",
    deviceUid: "Qurilma ID",
    lastSeen: "Oxirgi faollik",
    revoke: "Bekor qilish",
    revokeDevice: "Qurilmani bekor qilish",
    revokeConfirm:
      "{device} qurilmasi bekor qilinsinmi? Qurilma darhol tizimdan chiqariladi va qaytadan ro'yxatdan o'tishi kerak.",
    revokeSuccess: "Qurilma bekor qilindi",
    suspend: "To'xtatish",
    activate: "Faollashtirish",
    suspendConfirm:
      "{pinfl} foydalanuvchisi to'xtatilsinmi? U barcha qurilmalardan darhol chiqariladi.",
    activateConfirm: "{pinfl} foydalanuvchisi qayta faollashtirilsinmi?",
    suspendSuccess: "Foydalanuvchi to'xtatildi",
    activateSuccess: "Foydalanuvchi faollashtirildi",
    time: "Vaqt",
    eventType: "Hodisa turi",
    allEventTypes: "Barcha turlar",
    event_app_login: "Ilovaga kirish",
    event_qr_login: "QR orqali kirish",
    result: "Natija",
    allResults: "Barcha natijalar",
    result_approved: "tasdiqlangan",
    result_rejected: "rad etilgan",
    result_failed: "xatolik",
    systemName: "Tizim",
    similarity: "O'xshashlik",
    liveness: "Tiriklik",
    ip: "IP manzil",
    dateFrom: "Boshlanish",
    dateTo: "Tugash",
    scopes: "So'ralgan ruxsatlar",
    scannedAt: "Skanerlangan",
    completedAt: "Yakunlangan",
    expiresAt: "Amal qilish muddati",
    statsTitle: "Mobil ilova",
    totalUsers: "Jami foydalanuvchilar",
    activeDevices: "Faol qurilmalar",
    loginsToday: "Bugungi kirishlar",
    qrApprovalsToday: "Bugungi QR tasdiqlar",
    forbidden: "Bu sahifa faqat super adminlar uchun",
  },
  catalog: {
    servicesTitle: "Xizmatlar katalogi",
    servicesEmpty: "Xizmatlar topilmadi",
    searchPlaceholder: "Nomi bo'yicha qidirish",
    createService: "Yangi xizmat",
    editService: "Xizmatni tahrirlash",
    logo: "Logotip",
    logoUrl: "Logotip URL",
    logoDropHint: "Faylni bu yerga tashlang yoki tanlash uchun bosing",
    logoConstraints: "PNG, JPEG yoki WEBP · 2 MB gacha · 512×512 ga kichraytiriladi",
    logoTypeRejected: "Faqat PNG, JPEG yoki WEBP rasm yuklash mumkin",
    logoTooLarge: "Fayl hajmi 2 MB dan oshmasligi kerak",
    logoUploadSuccess: "Logotip yuklandi",
    logoFromUpload: "Yuklangan fayl",
    logoFromUrl: "Tashqi URL",
    logoRemove: "Logotipni olib tashlash",
    logoUseUrl: "yoki URL kiriting",
    name: "Nomi",
    category: "Toifa",
    allCategories: "Barcha toifalar",
    type: "Turi",
    allTypes: "Barcha turlar",
    type_web: "Veb sahifa",
    type_mobile: "Mobil ilova",
    link: "Havola",
    link_ios: "iOS",
    link_android: "Android",
    link_deeplink: "Deeplink",
    noLink: "Havola yo'q",
    url: "Veb sahifa URL",
    urlRequired: "Veb sahifa uchun URL majburiy",
    invalidUrl: "URL http:// yoki https:// bilan boshlanishi kerak",
    iosUrl: "iOS havolasi (App Store)",
    androidUrl: "Android havolasi (Google Play)",
    deeplink: "Deeplink",
    mobileLinksHint:
      "Kamida bittasini to'ldiring: iOS, Android yoki deeplink — aks holda ilova kartani ocha olmaydi.",
    mobileLinkRequired:
      "Kamida bitta havola kerak: iOS, Android yoki deeplink",
    company: "Kompaniya",
    companyPlaceholder: "Ixtiyoriy",
    order: "Tartib",
    orderHint: "Kichik raqam birinchi ko'rsatiladi",
    active: "Faol",
    allStatuses: "Barcha holatlar",
    statusActive: "Faol",
    statusInactive: "Nofaol",
    resetFilters: "Filtrlarni tozalash",
    noCategories: "Avval toifa yarating — xizmat toifasiz saqlanmaydi.",
    createServiceSuccess: "Xizmat yaratildi",
    updateServiceSuccess: "Xizmat yangilandi",
    deleteService: "Xizmatni o'chirish",
    deleteServiceConfirm:
      "{name} xizmati o'chirilsinmi? U mobil ilovada ko'rinmay qoladi.",
    deleteServiceSuccess: "Xizmat o'chirildi",
    categoriesTitle: "Xizmat toifalari",
    categoriesEmpty: "Toifalar yo'q",
    createCategory: "Yangi toifa",
    editCategory: "Toifani tahrirlash",
    key: "Kalit",
    keyHint: "a-z, 0-9, -, _",
    keyInvalid: "Kalit: a-z, 0-9, - va _, 2–64 belgi",
    keyImmutable: "Kalit yaratilgandan keyin o'zgartirilmaydi",
    nameUz: "Nomi (uz)",
    nameRu: "Nomi (ru)",
    nameEn: "Nomi (en)",
    createCategorySuccess: "Toifa yaratildi",
    updateCategorySuccess: "Toifa yangilandi",
    deleteCategory: "Toifani o'chirish",
    deleteCategoryConfirm: "{name} toifasi o'chirilsinmi?",
    deleteCategorySuccess: "Toifa o'chirildi",
    deleteCategoryBlocked: "Toifani o'chirib bo'lmadi",
    categoryInUseHint:
      "Avval bu toifadagi xizmatlarni boshqa toifaga ko'chiring yoki o'chiring.",
    forbidden: "Bu ma'lumotlarni o'zgartirish uchun ruxsat yo'q",
  },
  apiLogs: {
    title: "API loglar",
    endpoint: "Endpoint",
    method: "Metod",
    statusCode: "Status",
    duration: "Davomiylik",
    success: "Natija",
    errorCode: "Xato kodi",
    ip: "IP manzil",
    cached: "Kesh",
    timestamp: "Vaqt",
    allCodes: "Barcha kodlar",
    onlySuccess: "Faqat muvaffaqiyatli",
    onlyFailed: "Faqat xatolar",
  },
  auditLogs: {
    title: "Audit loglar",
    eventType: "Hodisa turi",
    actorType: "Aktyor",
    actorId: "Aktyor ID",
    ip: "IP manzil",
    payload: "Ma'lumot",
    createdAt: "Vaqt",
    allEvents: "Barcha hodisalar",
    allActors: "Barcha aktyorlar",
    view: "Ko'rish",
    detail: "Audit yozuvi",
  },
  members: {
    title: "Xodimlar",
    invite: "Xodim taklif qilish",
    email: "Email",
    role: "Rol",
    fullName: "To'liq ism",
    createdAt: "Qo'shilgan",
    roleOwner: "Egasi",
    roleAdmin: "Admin",
    roleViewer: "Kuzatuvchi",
    roleHint:
      "Hozircha uchalasi bir xil huquq beradi: shu kompaniya ma'lumotlari, faqat o'qish. Rol kelajak uchun saqlanadi.",
    changeRole: "Rolni o'zgartirish",
    remove: "O'chirish",
    removeConfirm: "Xodimni o'chirishni tasdiqlaysizmi?",
    inviteSuccess: "Xodim qo'shildi",
    roleSuccess: "Rol o'zgartirildi",
    removeSuccess: "Xodim o'chirildi",
    tempPasswordWarning: "Yangi foydalanuvchi yaratildi. Bu parol faqat HOZIR ko'rsatiladi!",
    tempPassword: "Vaqtinchalik parol",
  },
  applications: {
    title: "Ilovalar",
    create: "Yangi ilova",
    name: "Nomi",
    slug: "Slug",
    clientId: "client_id",
    clientSecret: "client_secret",
    webhookSecret: "Webhook maxfiy kaliti",
    webhookSecretHint:
      "Webhook'dagi X-FaceID-Signature header'ini tekshirish uchun HMAC kaliti.",
    rotateWebhookSecret: "Kalitni yangilash",
    rotateConfirm:
      "Bu ilovaning webhook kalitini yangilaymizmi? Eski kalit darhol ishlamay qoladi.",
    webhookSecretRotated: "Yangi webhook kaliti",
    rotateClientSecret: "Yangi client_secret",
    rotateClientConfirm:
      "Bu ilovaning client_secret'i yangilansinmi? Eski secret darhol ishlamay qoladi; client_id o'zgarmaydi.",
    clientSecretRotated: "Yangi client_secret",
    clientSecretHint:
      "Buni OAuth access-token so'rovida ishlating. client_id o'zgarmagan.",
    quota: "Oylik kvota",
    webhook: "Webhook URL",
    isWeb: "Web",
    isMobile: "Mobil",
    secretWarning: "Bu maxfiy kalit faqat HOZIR ko'rsatiladi. Saqlab qo'ying!",
    secretCopied: "Nusxalandi",
    createSuccess: "Ilova yaratildi",
    threshold: "O'xshashlik",
    thresholdEdit: "O'xshashlik chegarasi",
    thresholdHint:
      "Verifikatsiyadan o'tish uchun minimal yuz mos kelish darajasi (0.55–0.99). Qancha yuqori bo'lsa, shuncha qattiq. Standart 0.65.",
    securityTitle: "Ilova xavfsizlik sozlamalari",
    securitySuccess: "Ilova sozlamalari saqlandi",
    noChanges: "O'zgarish yo'q",
    checkSpoofHint:
      "Passiv anti-spoof modeli va deepfake/ekran tekshiruvi. O'chirilsa, chop etilgan foto yoki telefon ekranidagi rasm rad etilmaydi.",
    checkLivenessHint:
      "Boshni burish topshiriqlari. O'chirilsa, SDK bo'sh challenges ro'yxatini oladi — foydalanuvchidan boshini burish so'ralmaydi.",
    checkFrameTimeHint:
      "Har bir kadr qurilma tomonidan imzolanadi va QURILMANING o'z soati bo'yicha server soatidan 5 daqiqadan ko'p farq qilmasligi shart — oldinga ham, orqaga ham. Yoqilgan: telefoni yoki kompyuterining sanasi yoki vaqti noto'g'ri foydalanuvchi har doim «kadr buzilgan» deb rad etiladi, qayta urinish yordam bermaydi. O'chirilgan: kadrlar hamon imzolanadi va kriptografik tekshiriladi, faqat 5 daqiqalik oyna talab qilinmaydi — soatini to'g'rilash imkoni bo'lmagan qurilmalar uchun o'chiring.",
    checkAppAttestHint:
      "iOS kadrlari uchun Apple App Attest: Apple so'rov haqiqiy iPhone yoki iPad'dagi asl, o'zgartirilmagan ilovadan kelganini tasdiqlaydi. O'chirilsa, qayta qadoqlangan ilova, simulyator yoki skriptdan kelgan iOS kadri rad etilmaydi. Android va web'ga bu ta'sir qilmaydi.",
    challengeTypes: "Bosh harakati topshiriqlari",
    challengeTypesHint:
      "Har bir sessiyaga shu ro'yxatdan tasodifiy 2 tasi beriladi. Prod o'lchovi: pastga/tepaga qarash yon burilishdan 3.2 barobar ko'p yiqiladi (33.5% va 30.6% ga qarshi 10.3% va 9.8%), chunki telefon ko'krak balandligida ushlanganda bosh tabiiy ravishda pastga qaragan bo'ladi.",
    challengeTypesMin:
      "Kamida 2 tasi tanlanishi shart. Tekshiruvni butunlay o'chirish uchun yuqoridagi «Tiriklik» kalitidan foydalaning.",
    iosAppIds: "iOS App ID'lar",
    iosAppIdAdd: "Qo'shish",
    iosAppIdPlaceholder: "ABCDE12345.uz.company.app",
    iosAppIdsHint:
      "Bu ilova uchun qaysi Apple App ID'lar attestatsiyadan o'tishi mumkin — SDK bir nechta ilova ichida ishlaydi va har birining o'z App ID'si bor. Format: 10 belgili Team ID, nuqta, so'ng bundle id (Team ID bosh harflarda saqlanadi, bundle id qanday yozilsa shundayligicha). Eng ko'pi 20 ta. Ro'yxat bo'sh bo'lsa, serverning o'z standart App ID'si ishlatiladi.",
    iosAppIdsEmpty: "Ro'yxat yo'q — serverning standart App ID'si ishlatiladi.",
    iosAppIdInvalid:
      "Format TEAMID.bundle.id bo'lishi kerak — 10 belgili Team ID (A–Z, 0–9), nuqta, so'ng bundle id. Masalan: ABCDE12345.uz.company.app.",
    iosAppIdDuplicate: "Bu App ID ro'yxatda allaqachon bor",
    iosAppIdTooLong: "App ID eng ko'pi 255 belgi bo'lishi mumkin",
    iosAppIdLimit: "Eng ko'pi 20 ta App ID",
    checkOffTitle: "Xavfsizlik darajasi pasaytirilmoqda",
    checkOffConfirmButton: "Ha, o'chirilsin",
    checkSpoofOffConfirm:
      "Spoof tekshiruvi o'chirilsinmi? Shundan keyin chop etilgan foto yoki telefon ekranidagi rasm ham tekshiruvdan o'tadi.",
    checkLivenessOffConfirm:
      "Tiriklik tekshiruvi o'chirilsinmi? Foydalanuvchidan boshini burish so'ralmaydi, ya'ni uning jonli ekanligi tekshirilmaydi.",
    checkFrameTimeOffConfirm:
      "Kadr vaqti tekshiruvi o'chirilsinmi? Kadrlar hamon imzolanadi va kriptografik tekshiriladi, lekin kadr olinganidan ancha keyin ham qabul qilinadi — ya'ni yozib olingan kadrlarni o'sha sessiyaning o'ziga, u tugaguncha (10 daqiqa) qayta yuborish mumkin bo'ladi. Boshqa sessiyaning kadrlari baribir rad etiladi.",
    checkAppAttestOffConfirm:
      "App Attest tekshiruvi o'chirilsinmi? Shundan keyin iOS kadri Apple tasdig'isiz qabul qilinadi, ya'ni ilovangizning qayta qadoqlangan nusxasi, simulyator yoki skript ham kadr yuborishi mumkin bo'ladi.",
    credentials: "Kalitlar",
    shareLink: "Ulashish havolasi",
    shareConfirm:
      "Bir martalik ulashish havolasi yaratilsinmi? Bu client_secret VA webhook_secret'ni yangilaydi hamda oldingi havolani ishlamay qoldiradi.",
    shareTitle: "Bir martalik kalit havolasi",
    shareHint:
      "Qabul qiluvchi bu havolani ochib, kalitlarni faqat bir marta ko'ra oladi. Yangi havola yaratilsa, bu havola ishlamay qoladi.",
    shareUrl: "Ulashish havolasi",
    shareExpires: "Amal qilish muddati",
  },
  users: {
    title: "Backoffice foydalanuvchilari",
    create: "Yangi foydalanuvchi",
    edit: "Tahrirlash",
    email: "Email",
    invalidEmail: "Email noto'g'ri",
    password: "Parol",
    newPassword: "Yangi parol",
    passwordMin: "Kamida 8 ta belgi",
    changePassword: "Parolni o'zgartirish",
    fullName: "F.I.Sh.",
    role: "Rol",
    role_super_admin: "Super admin",
    role_moderator: "Moderator",
    role_bookkeeping: "Buxgalteriya",
    role_support: "Support",
    role_readonly: "Faqat o'qish",
    role_company_viewer: "Kompaniya (faqat ko'rish)",
    active: "Faol",
    activeYes: "Faol",
    activeNo: "O'chirilgan",
    lastLogin: "Oxirgi kirish",
    you: "siz",
    delete: "Foydalanuvchini o'chirish",
    deleteConfirm: "{email} o'chirilsinmi? Kirish darhol yopiladi.",
    createSuccess: "Foydalanuvchi yaratildi",
    updateSuccess: "Foydalanuvchi yangilandi",
    deleteSuccess: "Foydalanuvchi o'chirildi",
    passwordSuccess: "Parol o'zgartirildi",
  },
  common: {
    save: "Saqlash",
    cancel: "Bekor qilish",
    confirm: "Tasdiqlash",
    close: "Yopish",
    delete: "O'chirish",
    search: "Qidirish",
    refresh: "Yangilash",
    exportCsv: "CSV eksport",
    loading: "Yuklanmoqda...",
    empty: "Ma'lumot yo'q",
    requiredField: "Bu maydon majburiy",
    yes: "Ha",
    no: "Yo'q",
    locale: "Til",
    loadFailed: "Yuklab bo'lmadi",
    retry: "Qayta urinish",
    totalCapped: "Jami {n}+",
    totalCappedHint: "Server shu yerda sanashni to'xtatgan, ya'ni bu aniq jami emas, pastki chegara — millionlab satrni aniq sanash sahifaning o'zidan qimmatga tushadi. Sahifalash shu songa yetib tugaydi: undan keyingi satrlarga o'tish uchun sahifalashni davom etmang, filtrlarni toraytiring.",
  },
  errors: {
    network: "Tarmoq xatosi",
    serverError: "Server xatosi",
    notFound: "Topilmadi",
  },
  share: {
    appLabel: "Ilova",
    reveal: "Kalitlarni ko'rsatish",
    revealWarning:
      "Bu kalitlar faqat bir marta ko'rsatiladi — hoziroq nusxalab, saqlab qo'ying.",
    clientId: "client_id",
    clientSecret: "client_secret",
    webhookSecret: "Webhook maxfiy kaliti",
    loading: "Yuklanmoqda…",
    consumedTitle: "Allaqachon olingan",
    consumedBody:
      "Bu kalitlar allaqachon olingan va qayta ko'rsatilmaydi. Administratordan yangi havola yaratishni so'rang.",
    expiredTitle: "Havola muddati tugagan",
    expiredBody:
      "Bu havolaning muddati tugagan. Administratordan yangi havola yaratishni so'rang.",
    invalidTitle: "Noto'g'ri havola",
    invalidBody:
      "Bu havola noto'g'ri yoki endi mavjud emas. Administratordan yangi havola yaratishni so'rang.",
  },
};
